/* eslint-disable complexity */
import UserCenter from "@/layout/UserCenter";
import NavTab from "@/layout/NavTab";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { NavItemData } from "@/layout/NavItem";
import TeamList, { TeamItemInfo } from "@/layout/TeamList";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { getIconFromString } from "@/components/icon";
import { useLocation, useHistory } from "react-router-dom";
import ExtendNavs from "./ExtendNav/";
import _, { debounce } from "lodash";
import logger from "@/utils/logger";
import ChatState from "@/types/chat/State";
import { Employee, Session } from "@/types/chat";
import { connect } from "dva";
import "./index.less";
import { EbookState } from "@/models/ebook";
import chatConfig from "@/components/chat/config";
import lifecycle from "page-lifecycle";
import notifications from "@/notifications";
import { isFocusEnv } from "@/utils";
import { MessageNotifyType } from "@/types/chat/enum";
import { isAINoticeChildSession, isAINoticeSession } from "@/utils/chat/session";
import { message, Tooltip } from "antd";
import bus from "@/utils/bus";
import UAParser from "ua-parser-js";
import { analysisLog } from "@/utils/logAnalytics";
import ImService from "@/server/ImService";
import { isShieldSession } from "@/utils/chat/message";
import {
  crossAppSwitch,
  changeEgovUrl,
  getPcSideConfig,
  PC_SIDE_ITEM_NUM,
  isMebjJZB
} from "@/utils/tools";
import { ISideThemes, UserState } from "@/models/user";
import NavSettingBtn from "./NavSetting/index";
import { isLogin } from "@/utils/user";
import LoginBtn from "./LoginBtn";
import config, { ConfigEnum } from "@/config/config";
import touristMode from "@/utils/touristMode";
import { AppState } from "@/models";
import { ThirdAppState } from "@/models/thirdapp";
import ThemeIcon, { ThemeType } from "./ThemeIcon";

const { REACT_APP_X_FLAG } = process.env;

function LeftNav({
  newContactsCount,
  clearSelectSession,
  allSessionList,
  sessionUnReadList,
  sessionScrollIndex,
  selectedSessionId,
  // getNewContactsCount,
  setSessionScrollIndex,
  setTouristModePath,
  touristModePath,
  selectedNotifyType,
  customAppList,
  thirdAppMsgTotalCount,
  sideThemes,
  currentSelectedWorkbench: newCurrentSelectedWorkbench,
  currentEmployee,
  otherTeamNotifyList,
  teamConfig,
  pcFuncInfoMap,
  thirdAppMsgCount,
  themes,
  upgradeState,
  updateUpgradeVisable,
  loadAllSessionListEnd
}: {
  selectedSessionId: string;
  newContactsCount: number;
  clearSelectSession: Function;
  // getNewContactsCount: Function;
  allSessionList: Session[];
  sessionUnReadList: [];
  sessionScrollIndex: number;
  setSessionScrollIndex: Function;
  setTouristModePath: Function;
  touristModePath: any;
  selectedNotifyType: MessageNotifyType;
  currentSelectedWorkbench: any;
  customAppList: Session[];
  currentEmployee: any;
  sideThemes: ISideThemes;
  otherTeamNotifyList: any;
  teamConfig: any;
  pcFuncInfoMap: Map<string, any>;
  thirdAppMsgTotalCount: number;
  thirdAppMsgCount: Record<string, any>;
  themes: ThemeType;
  upgradeState: Record<string, any>;
  updateUpgradeVisable: Function;
  loadAllSessionListEnd: boolean;
}) {
  const location = useLocation();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(
    touristMode ? (touristModePath && touristModePath.path ? touristModePath.path : "homePage") : ""
  );
  const { authInfo, appRuntimeEnv, focusSDK, onGlobalError } = useContext<GlobalContextConfig>(
    GlobalContext
  );

  let localstorageKey =
    authInfo && authInfo?.userId ? `${authInfo.userId}_${authInfo.teamUserInfo.teamId}` : "";
  let historySelectedWorkbenchString = window.localStorage.getItem("currentSelectedWorkbench");
  let historySelectedWorkbench = historySelectedWorkbenchString
    ? JSON.parse(historySelectedWorkbenchString)
    : {};
  let currentSelectedWorkbench = Object.keys(newCurrentSelectedWorkbench).length
    ? newCurrentSelectedWorkbench
    : historySelectedWorkbench[localstorageKey] || {};
  const [messageTip, setMessageTip] = useState(0);
  const [innerWidth, setinnerWidth] = useState(false);
  const enableDuConfig = appRuntimeEnv.getUIConfig("enableDu");
  const enableDu = typeof enableDuConfig === "undefined" || enableDuConfig === true;
  const onTeamItemClick = useCallback(
    debounce((team: TeamItemInfo) => {
      if (!loadAllSessionListEnd) {
        return;
      }
      if (team.emplEnabled !== "DIS_ENABLED") {
        ImService.getInstance()?.logoutIm();
        focusSDK.switchTeam(team.teamId);
      } else {
        message.destroy();
        message.warn("该账号已被冻结，如有疑问请联系所在单位管理员进行核查。");
      }
    }, 1000),
    [focusSDK, loadAllSessionListEnd]
  );
  const navItems: NavItemData[] = [];
  let navData = appRuntimeEnv.ui.layout.nav;
  //   if (window.location.origin.includes("desktop.jdcloud.com")) {
  //     navData = [{ role: "index", icon: "iconshouye", name: "layout.nav.index" }, ...navData];
  //   }

  if (focusSDK.getDeviceInfo().platform === "web") {
    navData = _.filter(
      navData,
      (item) =>
        [
          "layout.nav.homePage",
          "layout.nav.messages",
          "layout.nav.ebook",
          "layout.nav.calendar",
          "layout.nav.joywork",
          "layout.nav.joyspace",
          "layout.nav.thirdApp"
        ].includes(item.name)
      // (item) =>
      //     ['layout.nav.messages', 'layout.nav.ebook', 'layout.nav.calendar'].includes(
      //         item.name
      //     )
    );
  }

  const realNumberTip = useMemo(() => {
    return messageTip <= 0
      ? ""
      : messageTip >= 100
      ? `${isMebjJZB() ? "..." : "99+"}`
      : `${messageTip}`;
  }, [messageTip]);

  const mergedNavItem = useMemo(() => {
    let items = [];
    const customItems = getPcSideConfig(teamConfig, {
      key: "items"
    });
    items = authInfo && customItems && customItems.length ? [...customItems] : [...navData];
    items = items.slice(0, PC_SIDE_ITEM_NUM);
    let res: NavItemData[] = [];
    items.forEach((item: any) => {
      const { icon, name, role, cnName, ...rest } = item;
      const data = authInfo ? pcFuncInfoMap?.get?.(name) : null;
      // Reflect.deleteProperty(data, "name");
      const title = data?.name || cnName || appRuntimeEnv.getI18N(name);
      switch (role) {
        case "messages": {
          res.push({
            icon: <ThemeIcon name="Chat" theme={themes} />,
            activeIcon: <ThemeIcon name="Chat" theme={themes} active={true} />,
            path: "/messages",
            navName: "messages",
            title,
            // tip: '',
            tip: realNumberTip,
            name,
            role,
            ...rest,
            iconUrl: data?.icon,
            iconSvg: data?.svg
          });
          break;
        }
        case "calendar": {
          res.push({
            icon: <ThemeIcon name="Calendar" theme={themes} />,
            activeIcon: <ThemeIcon name="Calendar" theme={themes} active={true} />,
            path: "/calendar",
            navName: "calendar",
            title,
            name,
            role,
            ...rest,
            iconUrl: data?.icon,
            iconSvg: data?.svg
          });
          break;
        }
        case "ebook": {
          res.push({
            icon: <ThemeIcon name="Contacts" theme={themes} />,
            activeIcon: <ThemeIcon name="Contacts" theme={themes} active={true} />,
            path: "/address_list",
            navName: "address_list",
            title,
            name,
            // 冬奥没有新申请数量
            tip:
              newContactsCount && REACT_APP_X_FLAG !== "olympic"
                ? newContactsCount >= 100
                  ? `${isMebjJZB() ? "..." : "99+"}`
                  : `${newContactsCount}`
                : "",
            role,
            ...rest,
            iconUrl: data?.icon,
            iconSvg: data?.svg
          });
          break;
        }
        case "thirdApp": {
          crossAppSwitch("threeApp") &&
            res.push({
              icon:
                currentSelectedWorkbench.workBenchType === 1 ? (
                  <img
                    className="coustom-workbench-logo"
                    alt=""
                    src={changeEgovUrl(currentSelectedWorkbench.pcNaviImage)}
                  />
                ) : (
                  <ThemeIcon name="Workplate" theme={themes} />
                ),
              activeIcon: <ThemeIcon name="Workplate" theme={themes} active={true} />,
              path: "/third_apps",
              navName: "third_apps",
              title,
              name,
              role,
              ...rest,
              iconUrl: data?.icon,
              iconSvg: data?.svg,
              tip:
                thirdAppMsgTotalCount <= 0
                  ? ""
                  : thirdAppMsgTotalCount >= 100
                  ? `${isMebjJZB() ? "..." : "99+"}`
                  : `${thirdAppMsgTotalCount}`
            });
          break;
        }
        case "meeting": {
          crossAppSwitch("meeting") &&
            res.push({
              icon: getIconFromString(icon),
              path: "/meeting",
              navName: "meeting",
              title,
              name,
              role,
              ...rest,
              iconUrl: data?.icon,
              iconSvg: data?.svg
            });
          break;
        }

        // }
        default:
          if (name === "layout.nav.joyspace" && crossAppSwitch("joyspace")) {
            res.push({
              icon: <ThemeIcon name="Joyspace" theme={themes} />,
              activeIcon: <ThemeIcon name="Joyspace" theme={themes} active={true} />,
              title,
              path: "/joyspace",
              role,
              name,
              ...rest,
              iconUrl: data?.icon,
              iconSvg: data?.svg
            });
          } else if (
            name === "layout.nav.joywork" &&
            crossAppSwitch("joywork", currentEmployee, appRuntimeEnv)
          ) {
            res.push({
              icon: <ThemeIcon name="Task" theme={themes} />,
              activeIcon: <ThemeIcon name="Task" theme={themes} active={true} />,
              title,
              role,
              path: "/joywork",
              name,
              ...rest,
              iconUrl: data?.icon,
              iconSvg: data?.svg
            });
          } else if (name === "layout.nav.homePage") {
            res.push({
              icon: getIconFromString("iconshouye"),
              title,
              role,
              path: "/homePage",
              name,
              ...rest,
              iconUrl: data?.icon,
              iconSvg: data?.svg
            });
          } else if (item.applicationId && item.sceneId) {
            const uuid = `${item.applicationId}_${item.sceneId}`;
            const badgeItem = thirdAppMsgCount[`${uuid}`];
            // 三方应用
            res.push({
              iconUrl: item.avatar,
              iconSvg: item.svg,
              path: role,
              role,
              title,
              name,
              ...rest,
              uuid: item.uuid || uuid,
              tip: badgeItem?.showBadge ? badgeItem?.badge || 0 : 0
            });
          } else if (data && data.pcUrl) {
            res.push({
              icon: getIconFromString(icon),
              iconUrl: data?.icon,
              iconSvg: data?.svg,
              role: "loadUrl",
              navName: "linkContainer",
              title,
              name,
              ...rest,
              uuid: item.sceneId,
              path: "/linkContainer",
              pcUrl: data?.pcUrl
            });
          }
      }
    });
    // crossAppSwitch("meeting") &&
    //   res.push({
    //     icon: getIconFromString("iconic_pc_im_joymeeting_video"),
    //     path: "/meeting",
    //     navName: "meeting_lite",
    //     title: "会议"
    //   });
    // if (process.env.NODE_ENV !== "production") {
    //   res.push({
    //     icon: getIconFromString("iconzw_app_project"),
    //     title: "测试页",
    //     path: "/tests"
    //   });
    // }
    return res;
  }, [
    teamConfig,
    authInfo,
    navData,
    pcFuncInfoMap,
    appRuntimeEnv,
    currentEmployee,
    messageTip,
    newContactsCount,
    realNumberTip,
    currentSelectedWorkbench.workBenchType,
    currentSelectedWorkbench.pcNaviImage,
    thirdAppMsgCount,
    themes
  ]);
  // const newContactsCountTip = useMemo(() => {
  //     const search: any = appRuntimeEnv.getUIConfig('ebook.search') || {};
  //     if (search.addContract) {
  //         // 只有开启添加联系人的功能才会有提示
  //         return newContactsCount <= 0
  //             ? ''
  //             : newContactsCount >= 100
  //             ? '...'
  //             : `${newContactsCount}`;
  //     }
  //     return '';
  // }, [appRuntimeEnv, newContactsCount]);

  // // 拉取新的申请数量
  // useEffect(() => {
  //     getNewContactsCount();
  // }, [getNewContactsCount]);

  const sTimer = React.useRef<any>();
  const messageCount = React.useRef<any>({
    time: Date.now()
  });
  const lastMessageCount = React.useRef<any>({
    time: Date.now()
  });

  const DURATION_TIME = 60 * 1000;

  // 当前总条数
  const unReadTotal = React.useRef(0);
  // 上次总条数
  const lastUnReadTotal = React.useRef(0);
  const notifyText = "您有新消息，请及时查看";

  // 发完通知1分钟后将未发的通知再发出来
  const timer = useCallback(() => {
    clearTimeout(sTimer.current);
    sTimer.current = setTimeout(() => {
      if (lifecycle.state === "hidden") {
        // 消息数有变化且当前消息数不为0
        if (unReadTotal.current > 0 && unReadTotal.current !== lastUnReadTotal.current) {
          let result = notifications("消息提醒", {
            body: notifyText
          });
          // 如果没发通知不更新时间
          if (!result) {
            return;
          }
          console.log(
            `延迟到间隔1分钟，上次总条数${lastUnReadTotal.current}，当前总条数${unReadTotal.current}`
          );
          lastUnReadTotal.current = unReadTotal.current;
          lastMessageCount.current = {
            time: Date.now()
          };
          timer();
        }
      }
    }, DURATION_TIME);
  }, [DURATION_TIME]);
  const bjwpConfig = appRuntimeEnv.bjwpConfig;

  // 页面状态变化时改变定时器计时及进入hidden一分钟后要通知
  useEffect(() => {
    const changeHidden = (event: any) => {
      if (isFocusEnv()) {
        return;
      }
      let { newState } = event;
      // 变为失去焦点状态
      if (newState === "hidden") {
        messageCount.current = { ...messageCount.current, ...{ time: Date.now() } };
        timer();
      }
      // 变为激活状态
      if (newState === "active" || newState === "passive") {
        let time = Date.now();
        messageCount.current = {
          time
        };
        lastMessageCount.current = {
          time
        };
      }
    };
    lifecycle.addEventListener("statechange", changeHidden);
    return () => {
      lifecycle.removeEventListener("statechange", changeHidden);
    };
  }, [timer]);

  // 增加横纵向置顶的会话过滤
  const isTopSessionOrNotDeleted = (session: Session) => {
    return ((session?.settings?.top || 0) > 0 || session.del === 0) && !isAINoticeSession(session);
  };

  useEffect(() => {
    if (allSessionList.length > 0) {
      const aiSession = allSessionList.find((item) => isAINoticeSession(item));
      const unReadCount = allSessionList
        .filter((session) => {
          // 过滤非置顶且del：1的会话
          return isTopSessionOrNotDeleted(session);
        })
        .reduce((total, s) => {
          let num = total;
          if (
            !isShieldSession(s) &&
            !(
              s.isSingle &&
              chatConfig["chat-session-invisible-list"].includes((s.info as Employee).userId)
            )
          ) {
            if (
              aiSession &&
              isShieldSession(aiSession) &&
              s.isNotice &&
              isAINoticeChildSession(s, customAppList)
            ) {
              return num;
            }
            num += s.unreadCount || 0;
            if (s.unreadCount !== 0) {
              console.log(
                "getAllSessionList===unReadCount",
                s,
                s.unreadCount,
                isAINoticeSession(s),
                isAINoticeChildSession(s, customAppList)
              );
            }
          }
          return num;
        }, 0);
      unReadTotal.current = unReadCount;
      if (unReadCount > 0) {
        if (lifecycle.state === "hidden" && !isFocusEnv()) {
          // 来了一条新消息
          let { time } = messageCount.current;
          time = Date.now();
          messageCount.current = {
            time // 新消息时间
          };
          let { time: lastTime } = lastMessageCount.current;
          // 超过60秒发起通知
          if (time - lastTime >= DURATION_TIME && lastUnReadTotal.current !== unReadCount) {
            let result = notifications("消息提醒", {
              body: notifyText
            });
            if (!result) {
              return;
            }
            console.log(
              `来了一条新消息，上次总条数${lastUnReadTotal.current}，当前总条数${unReadCount}`
            );
            lastUnReadTotal.current = unReadCount;
            // 记录上次通知时间
            lastMessageCount.current = {
              time
            };
            timer();
          }
        }
      }
      setMessageTip(unReadCount);
      if (isFocusEnv()) {
        focusSDK.setAppBadgeCount(unReadCount);
      }
    }
  }, [allSessionList, selectedSessionId, customAppList]); //eslint-disable-line
  // eslint-disable-next-line complexity
  navData.forEach((item: any) => {
    const { icon, name, role, ...rest } = item;
    const title = appRuntimeEnv.getI18N(name) || "首页";
    switch (role) {
      case "homePage": {
        navItems.push({
          icon: getIconFromString(icon),
          path: "/homePage",
          navName: "homePage",
          title
          // tip: '',
          // tip: messageTip <= 0 ? "" : messageTip >= 100 ? "..." : `${messageTip}`
        });
        break;
      }
      case "messages": {
        navItems.push({
          icon: getIconFromString(icon),
          path: "/messages",
          navName: "messages",
          title,
          // tip: '',
          tip: messageTip <= 0 ? "" : messageTip >= 100 ? "..." : `${messageTip}`
        });
        // navItems.push({
        //   icon: getIconFromString(icon),
        //   path: "/messages",
        //   navName: "messages",
        //   title,
        //   // tip: '',
        //   tip: messageTip <= 0 ? "" : messageTip >= 100 ? "..." : `${messageTip}`
        // });
        break;
      }
      case "calendar": {
        navItems.push({
          icon: getIconFromString(icon),
          path: "/calendar",
          navName: "calendar",
          title
        });
        break;
      }
      case "ebook": {
        navItems.push({
          icon: getIconFromString(icon || "iconapp_btn_addressbook"),
          path: "/address_list",
          navName: "address_list",
          title,
          // 冬奥没有新申请数量
          tip:
            newContactsCount && REACT_APP_X_FLAG !== "olympic"
              ? newContactsCount >= 100
                ? "..."
                : `${newContactsCount}`
              : ""
        });
        break;
      }
      case "thirdApp": {
        crossAppSwitch("threeApp") &&
          navItems.push({
            icon:
              currentSelectedWorkbench.workBenchType === 1 ? (
                <img
                  className="coustom-workbench-logo"
                  alt=""
                  src={changeEgovUrl(currentSelectedWorkbench.pcNaviImage)}
                />
              ) : (
                getIconFromString(icon || "iconxiaoxi")
              ),
            path: "/third_apps",
            navName: "third_apps",
            title,
            tip:
              thirdAppMsgTotalCount <= 0
                ? ""
                : thirdAppMsgTotalCount >= 100
                ? "..."
                : `${thirdAppMsgTotalCount}`
          });
        break;
      }
      case "meeting": {
        crossAppSwitch("meeting") &&
          navItems.push({
            icon: getIconFromString(icon),
            path: "/meeting",
            navName: "meeting",
            title
          });
        break;
      }
      // case 'third_email': {
      //     navItems.push({
      //         // icon: getIconFromString('iconapp_btn_pc_mail'),
      //         // title: '邮箱',
      //         icon: getIconFromString(icon),
      //         path: '/third_email',
      //         title,
      //     });
      //     break;
      // }
      default:
        if (name === "layout.nav.joyspace" && crossAppSwitch("joyspace")) {
          navItems.push({
            icon: getIconFromString(icon),
            title,
            role,
            ...rest
          });
        } else if (
          name === "layout.nav.joywork" &&
          crossAppSwitch("joywork", currentEmployee, appRuntimeEnv)
        ) {
          navItems.push({
            icon: getIconFromString(icon),
            title,
            role,
            ...rest
          });
        }
      // navItems.push({
      //   icon: getIconFromString(icon),
      //   title,
      //   role,
      //   ...rest
      // });
    }
  });
  // crossAppSwitch("meeting") &&
  //   navItems.push({
  //     icon: getIconFromString("iconic_pc_im_joymeeting_video"),
  //     path: "/meeting",
  //     navName: "meeting_lite",
  //     title: "会议"
  //   });
  // navItems.push({
  //     path: '/xylink',
  //     title: '会议',
  //     icon: getIconFromString('iconzw_app_project'),
  // });
  // if (currentEmployee?.teamId === bjwpConfig.teamId) {
  //   navItems.push({
  //     icon: getIconFromString("iconbjwp"),
  //     title: bjwpConfig.title || "新网评",
  //     path: "/wangPinSys"
  //   });
  // }
  //   if (process.env.NODE_ENV !== "production") {
  //     navItems.push({
  //       icon: getIconFromString("iconzw_app_project"),
  //       title: "测试页",
  //       path: "/tests"
  //     });
  //   }
  // const setUnread = useCallback(({ count }: { count: number }) => {
  //     setMessageTip(count);
  // }, []);
  //
  // const unreadCb = useRef(_.debounce(setUnread, 300)).current;

  const doClearSelectSession = useCallback(() => {
    clearSelectSession();
    ImService.getInstance()?.setCurrentSession("");
  }, [clearSelectSession]);

  // useEffect(() => {
  //     EventBus.on('chat_message_unread_count', unreadCb);
  //     return () => {
  //         EventBus.off('chat_message_unread_count', unreadCb);
  //     };
  // }, []); // eslint-disable-line

  const handleChangeActiveScene = (id: string) => {
    setActiveTab(id);
  };
  useEffect(() => {
    bus
      .off("layout:LeftNav:scene-item-change")
      .on("layout:LeftNav:scene-item-change", handleChangeActiveScene);
    return () => {
      bus.off("layout:LeftNav:scene-item-change", handleChangeActiveScene);
    };
  }, []);

  useEffect(() => {
    if (!location?.pathname?.includes("linkContainer")) {
      setActiveTab(location.pathname);
    }
  }, [location?.pathname]);
  // let winLeftSideStyle = {};
  // // Windows 头像到边界的距离过高
  // const platform = navigator.platform;
  // if (platform.toLowerCase().indexOf('win') >= 0) {
  //     winLeftSideStyle = {
  //         marginTop: 19,
  //     };
  // }

  // 双击未读消息定位
  const doDoubleClick = useCallback(
    (item) => {
      if (item.path !== "/messages" || selectedNotifyType !== MessageNotifyType.ALL) {
        return;
      }
      const sessionUnReadCount = sessionUnReadList.length;
      console.log("sessionUnReadListsessionUnReadList", sessionUnReadList, sessionUnReadCount);
      console.log("sessionScrollIndex", sessionScrollIndex);
      
      // 修复单条消息循环定位问题
      if (sessionUnReadCount <= 1) {
       // 单条消息时，通过在-1和0之间切换来强制触发重新定位
        const newIndex = sessionScrollIndex === 0 ? -1 : 0;
        console.log("单条消息循环定位，设置索引为:", newIndex);
        setSessionScrollIndex({ sessionScrollIndex: newIndex });
      } else if (sessionScrollIndex < sessionUnReadCount - 1) {
        // 多条消息时的正常递增逻辑
        setSessionScrollIndex({ sessionScrollIndex: sessionScrollIndex + 1 });
      } else {
        // 多条消息时的重置逻辑
        setSessionScrollIndex({ sessionScrollIndex: 0 });
      }
    },
    [sessionScrollIndex, sessionUnReadList, setSessionScrollIndex, selectedNotifyType]
  );
  const isMac = useMemo(() => {
    let platform = focusSDK.getDeviceInfo().platform;
    if (platform === "web") {
      let uaParser = new UAParser();
      let os = uaParser.getOS();
      return (os?.name as string).indexOf("Mac") > -1 || (os?.name as string).indexOf("iOS") > -1;
    }
    return platform === "darwin";
  }, [focusSDK]);
  useEffect(() => {
    bus.off("layout:LeftNav").on("layout:LeftNav", (data) => {
      if (data < 960 && isMac) {
        setinnerWidth(true);
      } else {
        setinnerWidth(false);
      }
    });
  });
  const checkUpdate = useCallback(() => {
    updateUpgradeVisable?.({
      visible: true
    });
  }, []);
  return (
    <div
      className={`leftSide draggable ${
        innerWidth === true || (window.innerWidth < 960 && isMac) ? "minLeftSide" : ""
      }`}
      style={
        sideThemes.primary ? { backgroundColor: sideThemes.primary, backgroundImage: "none" } : {}
      }
    >
      {authInfo && <UserCenter />}
      {!authInfo && <LoginBtn />}
      {authInfo && upgradeState?.show && (
        <Tooltip title="发现新版本啦，点击查看" placement="right">
          <div className="upgradeTip" onClick={checkUpdate}>
            <span />
          </div>
        </Tooltip>
      )}
      <NavTab
        activeKey={activeTab}
        navItems={mergedNavItem}
        onItemClick={(item) => {
          if (item.navName === "navMore") {
            return;
          }
          if (item.uuid) {
            setActiveTab(item.uuid);
            return;
          }
          analysisLog("xtbg_jzb_leftMenu", (item.path || "").replace("/", ""));
          // 清空当前会话数据, 237 保留页面缓存
          // doClearSelectSession();
          if (item.role === "openNewWindow") {
            try {
              const url = new URL(item.link);
              window.open(url.toString());
            } catch (e) {
              onGlobalError(`Invalid url: ${item.link}`);
            }
          } else {
            if (!isLogin(appRuntimeEnv) && item.path !== "/homePage") {
              setTouristModePath({
                path: item.path,
                type: "path",
                name: item.name
              });
              focusSDK.emit("showLogin", {
                path: item.path,
                type: "path"
              });
              return;
            }
            history.push(item.path);
          }
          bus.emit("supervise:IconActive", false);
          // setActiveTab(path);
        }}
        onDoubleClick={doDoubleClick}
      >
        {authInfo && <NavSettingBtn />}
      </NavTab>
      <div className="no-draggable no-draggable-color">
        {enableDu && (
          <ExtendNavs
            active={activeTab?.indexOf?.("supervise") !== -1}
            clickHandle={(p: any) => {
              history.push(p);
            }}
          />
        )}
        {authInfo && (
          <TeamList
            selectedTeamId={appRuntimeEnv.selectedTeamId}
            teams={authInfo.teamUserInfoList}
            onItemClick={onTeamItemClick}
            otherTeamNotifyList={otherTeamNotifyList}
          />
        )}
      </div>
    </div>
  );
}

function mapStateToProps({
  user,
  ebook,
  chat,
  workbench,
  thirdapp
}: {
  user: UserState;
  chat: ChatState;
  ebook: EbookState;
  workbench: any;
  thirdapp: ThirdAppState;
}) {
  const { sideThemes, teamConfig, pcFuncInfoMap, themes, upgradeState } = user;
  const { newContactsCount } = ebook;
  const { currentSelectedWorkbench } = workbench;
  const { thirdAppMsgCount, thirdAppMap } = thirdapp;
  const thirdAppMsgTotalCount: number = Object.keys(thirdAppMsgCount).reduce((prev, current) => {
    let _prev = prev;
    _prev =
      thirdAppMap[current] !== undefined
        ? _prev + (thirdAppMsgCount[current]?.showBadge ? thirdAppMsgCount[current]?.badge || 0 : 0)
        : _prev;
    return _prev;
  }, 0);
  const {
    allSessionList,
    selectedSession,
    sessionUnReadList,
    sessionScrollIndex,
    selectedNotifyType,
    customAppList,
    currentEmployee,
    otherTeamNotifyList,
    loadAllSessionListEnd
  } = chat;
  return {
    newContactsCount,
    allSessionList,
    sessionUnReadList,
    sessionScrollIndex,
    selectedNotifyType,
    selectedSessionId: selectedSession.sessionId || "",
    currentSelectedWorkbench,
    customAppList,
    currentEmployee,
    sideThemes,
    otherTeamNotifyList,
    teamConfig,
    thirdAppMsgCount,
    pcFuncInfoMap,
    themes,
    upgradeState,
    thirdAppMsgTotalCount,
    loadAllSessionListEnd
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    clearSelectSession: () => {
      dispatch({ type: "chat/clearSelectSession", payload: {} });
    },
    setSessionScrollIndex: (data: any) => {
      dispatch({ type: "chat/setSessionScrollIndex", payload: data });
    },
    updateUpgradeVisable(data: any) {
      dispatch({ type: "user/updateUpgradeVisable", payload: data });
    },
    setTouristModePath(data: any) {
      dispatch({ type: "user/setTouristModePath", payload: data });
    }
    // getNewContactsCount(payload: {}) {
    //     return dispatch({ type: 'ebook/getNewContactsCount', payload });
    // },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LeftNav);
